import {
    PatsnapCopilotIntentRendererContribution,
    PatsnapCopilotIntentRendererRegistry,
    PatsnapCopilotIntentRendererRegistryImpl,
} from '@analytics/patsnap-copilot/src/patsnap-copilot-renderer';
import { PatsnapCopilotService } from '@analytics/patsnap-copilot/src/patsnap-copilot-service.interface';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ProjectCopilotServiceImpl } from '@/services/project-copilot-service';
import {
    PatsnapCopilotMessageSender,
    PatsnapCopilotMessageSenderImpl,
} from '@analytics/patsnap-copilot/src/patsnap-copilot-message-sender';
import { WuJieBus } from '@analytics/patsnap-copilot/src/wujie-bus';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import WujieVue from 'wujie-vue3';
import {
    PatsnapCopilotFeedBackService,
    PatsnapCopilotFeedBackServiceImpl,
} from '@eureka/services/src/patsnap-copilot-feedback-service';

export const projectCopilotModule = new ContainerModule((bind) => {
    const { bus } = WujieVue;
    bind(WuJieBus).toConstantValue(bus);
    bind(PatsnapCopilotMessageSender).to(PatsnapCopilotMessageSenderImpl);
    bindContributionProvider(bind, PatsnapCopilotIntentRendererContribution);
    bind(PatsnapCopilotIntentRendererRegistry).to(
        PatsnapCopilotIntentRendererRegistryImpl
    );
    bind(PatsnapCopilotService).to(ProjectCopilotServiceImpl);
    bind(PatsnapCopilotFeedBackService).to(PatsnapCopilotFeedBackServiceImpl);
});
